import { always } from 'ramda';

/**
 * A function that returns `null`.
 *
 * @func stubNull
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.6.0|v1.6.0}
 * @category Function
 * @sig ... -> null
 * @return {null}
 * @example
 *
 * RA.stubNull(); //=> null
 * RA.stubNull(1, 2, 3); //=> null
 */
var stubNull = /*#__PURE__*/always(null);

export default stubNull;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/stubNull.js
// module id = 759
// module chunks = 0